import * as actions from './actions';
import { state, mutations } from './mutations';

export default {
  state,
  actions,
  mutations,
};